import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../firebaseConfig";

const BLOGS_COLLECTION = "blogs";

const blogCollection = collection(db, BLOGS_COLLECTION);

export function generateBlogSlug(value) {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

function normalizeBlogPost(docSnapshot) {
  return {
    id: docSnapshot.id,
    ...docSnapshot.data(),
  };
}

export async function createBlogPost(data) {
  const docRef = await addDoc(blogCollection, {
    ...data,
    tags: Array.isArray(data.tags) ? data.tags : [],
    status: data.status || "draft",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    publishedAt: data.status === "published" ? serverTimestamp() : null,
  });

  return docRef.id;
}

export async function updateBlogPost(blogId, data) {
  const blogRef = doc(db, BLOGS_COLLECTION, blogId);
  await updateDoc(blogRef, {
    ...data,
    tags: Array.isArray(data.tags) ? data.tags : [],
    publishedAt: data.status === "published" ? serverTimestamp() : null,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteBlogPost(blogId) {
  await deleteDoc(doc(db, BLOGS_COLLECTION, blogId));
}

export async function getAllBlogPostsForAdmin() {
  const snapshot = await getDocs(query(blogCollection, orderBy("createdAt", "desc")));
  return snapshot.docs.map(normalizeBlogPost);
}

export async function getPublishedBlogPosts() {
  const snapshot = await getDocs(
    query(blogCollection, where("status", "==", "published"))
  );
  return snapshot.docs
    .map(normalizeBlogPost)
    .sort((a, b) => {
      const first = a.publishedAt?.toDate ? a.publishedAt.toDate().getTime() : new Date(a.publishedAt || 0).getTime();
      const second = b.publishedAt?.toDate ? b.publishedAt.toDate().getTime() : new Date(b.publishedAt || 0).getTime();
      return second - first;
    });
}

export async function getBlogPostById(blogId) {
  const snapshot = await getDoc(doc(db, BLOGS_COLLECTION, blogId));
  return snapshot.exists() ? normalizeBlogPost(snapshot) : null;
}

export async function getBlogPostBySlug(slug) {
  const snapshot = await getDocs(
    query(
      blogCollection,
      where("slug", "==", slug),
      where("status", "==", "published"),
      limit(1)
    )
  );

  return snapshot.empty ? null : normalizeBlogPost(snapshot.docs[0]);
}

export async function publishBlogPost(blogId) {
  await updateDoc(doc(db, BLOGS_COLLECTION, blogId), {
    status: "published",
    publishedAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function unpublishBlogPost(blogId) {
  await updateDoc(doc(db, BLOGS_COLLECTION, blogId), {
    status: "draft",
    publishedAt: null,
    updatedAt: serverTimestamp(),
  });
}

export async function uploadBlogCoverImage(file) {
  const safeFileName = file.name.replace(/[^a-zA-Z0-9._-]/g, "-");
  const imageRef = ref(storage, `blog-covers/${Date.now()}-${safeFileName}`);
  await uploadBytes(imageRef, file);
  return getDownloadURL(imageRef);
}
